module.exports = __webpack_public_path__ + "media/images/img-hobby-6-815c6580.jpg";